import { TAmenity } from "./types";

export const enum WSMessageType {
    ORDER = "ORDER",
    PAYMENT = "PAYMENT",
    NOTIFICATION = "NOTIFICATION",
    STORESALE = "STORESALE"
}

export const enum OrderStatus {
    ALL = "All",
    COMPLETED = "Completed",
    CANCELLED = "Cancelled",
    CREATED = "Created",
    DISPATCHED = "Dispatched",
    PROCESSING = "Processing"
}

export const allAmenities: TAmenity[] = [
    // 🛏️ Room / Stay Amenities
    { id: 1, name: "Air Conditioning", category: "Room", icon: "Wind" },
    { id: 2, name: "Heating", category: "Room", icon: "Thermometer" },
    { id: 3, name: "Fan", category: "Room", icon: "Fan" },
    { id: 4, name: "Bed", category: "Room", icon: "Bed" },
    { id: 5, name: "Extra Bed", category: "Room", icon: "BedDouble" },
    { id: 6, name: "Sofa Bed", category: "Room", icon: "Sofa" },
    { id: 7, name: "Wardrobe / Closet", category: "Room", icon: "DoorClosed" },
    { id: 8, name: "Dressing Table", category: "Room", icon: "Table" },
    { id: 9, name: "Desk / Work Table", category: "Room", icon: "Laptop" },
    { id: 10, name: "Chair", category: "Room", icon: "Armchair" },
    { id: 11, name: "Mirror", category: "Room", icon: "Square" },
    { id: 12, name: "Blackout Curtains", category: "Room", icon: "Moon" },
    { id: 13, name: "Soundproof Rooms", category: "Room", icon: "VolumeX" },
    { id: 14, name: "Carpeted Floor", category: "Room", icon: "Layers" },
    { id: 15, name: "Wooden Flooring", category: "Room", icon: "Grid" },
    // 🚿 Bathroom Amenities
    { id: 16, name: "Attached Bathroom", category: "Bathroom", icon: "Bath" },
    { id: 17, name: "Hot Water", category: "Bathroom", icon: "Droplets" },
    { id: 18, name: "Shower", category: "Bathroom", icon: "ShowerHead" },
    { id: 19, name: "Bathtub", category: "Bathroom", icon: "Bath" },
    { id: 20, name: "Jacuzzi", category: "Bathroom", icon: "Waves" },
    { id: 21, name: "Towels", category: "Bathroom", icon: "Layers" },
    { id: 22, name: "Bathrobes", category: "Bathroom", icon: "Shirt" },
    { id: 23, name: "Slippers", category: "Bathroom", icon: "Footprints" },
    { id: 24, name: "Toiletries", category: "Bathroom", icon: "Soap" },
    { id: 25, name: "Hair Dryer", category: "Bathroom", icon: "Wind" },
    { id: 26, name: "Shaving Kit", category: "Bathroom", icon: "Scissors" },
    { id: 27, name: "Dental Kit", category: "Bathroom", icon: "Smile" },
    { id: 28, name: "Western Toilet", category: "Bathroom", icon: "Toilet" },
    { id: 29, name: "Bidet", category: "Bathroom", icon: "Droplet" },
    { id: 30, name: "Geyser", category: "Bathroom", icon: "Flame" },
    { id: 31, name: "24x7 Water Supply", category: "Bathroom", icon: "Droplets" },

    // 📺 Entertainment & Electronics
    { id: 32, name: "Television", category: "Entertainment", icon: "Tv" },
    { id: 33, name: "Smart TV", category: "Entertainment", icon: "Monitor" },
    { id: 34, name: "Cable TV", category: "Entertainment", icon: "Cable" },
    { id: 35, name: "Streaming Apps", category: "Entertainment", icon: "PlayCircle" },
    { id: 36, name: "Wi-Fi", category: "Entertainment", icon: "Wifi" },
    { id: 37, name: "High-Speed Internet", category: "Entertainment", icon: "SignalHigh" },
    { id: 38, name: "Telephone", category: "Entertainment", icon: "Phone" },
    { id: 39, name: "Music System", category: "Entertainment", icon: "Music" },
    { id: 40, name: "Bluetooth Speaker", category: "Entertainment", icon: "Speaker" },
    { id: 41, name: "Gaming Console", category: "Entertainment", icon: "Gamepad2" },

    // 🍽️ Food & Kitchen
    { id: 42, name: "Kitchen", category: "Kitchen", icon: "ChefHat" },
    { id: 43, name: "Kitchenette", category: "Kitchen", icon: "Utensils" },
    { id: 44, name: "Refrigerator", category: "Kitchen", icon: "Refrigerator" },
    { id: 45, name: "Microwave", category: "Kitchen", icon: "Microwave" },
    { id: 46, name: "Oven", category: "Kitchen", icon: "Microwave" },
    { id: 47, name: "Stove / Induction", category: "Kitchen", icon: "Flame" },
    { id: 48, name: "Electric Kettle", category: "Kitchen", icon: "Kettle" },
    { id: 49, name: "Coffee Maker", category: "Kitchen", icon: "Coffee" },
    { id: 50, name: "Tea Maker", category: "Kitchen", icon: "CupSoda" },
    { id: 51, name: "Toaster", category: "Kitchen", icon: "Sandwich" },
    { id: 52, name: "Cookware", category: "Kitchen", icon: "Utensils" },
    { id: 53, name: "Cutlery", category: "Kitchen", icon: "UtensilsCrossed" },
    { id: 54, name: "Dining Table", category: "Kitchen", icon: "Table" },
    { id: 55, name: "Room Service", category: "Food", icon: "Bell" },
    { id: 56, name: "Breakfast Included", category: "Food", icon: "Coffee" },
    { id: 57, name: "Mini Bar", category: "Food", icon: "Wine" },

    // 🧹 Cleaning & Laundry
    { id: 58, name: "Housekeeping", category: "Cleaning & Laundry", icon: "Broom" },
    { id: 59, name: "Laundry Service", category: "Cleaning & Laundry", icon: "Shirt" },
    { id: 60, name: "Daily Cleaning", category: "Cleaning & Laundry", icon: "CalendarCheck" },
    { id: 61, name: "Washing Machine", category: "Cleaning & Laundry", icon: "WashingMachine" },
    { id: 62, name: "Iron", category: "Cleaning & Laundry", icon: "Zap" },
    { id: 63, name: "Ironing Board", category: "Cleaning & Laundry", icon: "RectangleHorizontal" },
    { id: 64, name: "Dry Cleaning", category: "Cleaning & Laundry", icon: "Droplets" },
    { id: 65, name: "Linen Change", category: "Cleaning & Laundry", icon: "Layers" },

    // 🔐 Safety
    { id: 66, name: "CCTV", category: "Safety", icon: "Cctv" },
    { id: 67, name: "Security Guard", category: "Safety", icon: "ShieldCheck" },
    { id: 68, name: "Safe Locker", category: "Safety", icon: "Lock" },
    { id: 69, name: "Fire Extinguisher", category: "Safety", icon: "Flame" },
    { id: 70, name: "Smoke Detector", category: "Safety", icon: "AlertTriangle" },
    { id: 71, name: "First Aid Kit", category: "Safety", icon: "HeartPulse" },
    { id: 72, name: "Emergency Exit", category: "Safety", icon: "DoorOpen" },
    { id: 73, name: "Door Lock", category: "Safety", icon: "Key" },
    { id: 74, name: "Intercom", category: "Safety", icon: "PhoneCall" },

    // 🏊 Recreation & Wellness
    { id: 75, name: "Swimming Pool", category: "Recreation", icon: "Waves" },
    { id: 76, name: "Indoor Pool", category: "Recreation", icon: "Droplets" },
    { id: 77, name: "Gym / Fitness Center", category: "Recreation", icon: "Dumbbell" },
    { id: 78, name: "Yoga Room", category: "Recreation", icon: "Lotus" },
    { id: 79, name: "Spa", category: "Recreation", icon: "Flower2" },
    { id: 80, name: "Sauna", category: "Recreation", icon: "ThermometerSun" },
    { id: 81, name: "Steam Room", category: "Recreation", icon: "Cloud" },
    { id: 82, name: "Massage", category: "Recreation", icon: "Hand" },
    { id: 83, name: "Game Room", category: "Recreation", icon: "Gamepad2" },
    { id: 84, name: "Table Tennis", category: "Recreation", icon: "CircleDot" },
    { id: 85, name: "Billiards", category: "Recreation", icon: "Circle" },
    { id: 86, name: "Kids Play Area", category: "Recreation", icon: "Baby" },
    { id: 87, name: "Garden", category: "Recreation", icon: "Leaf" },
    { id: 88, name: "Lawn", category: "Recreation", icon: "Table" },

    // 🚗 Parking & Transport
    { id: 89, name: "Free Parking", category: "Parking & Transport", icon: "ParkingSquare" },
    { id: 90, name: "Paid Parking", category: "Parking & Transport", icon: "ParkingCircle" },
    { id: 91, name: "Valet Parking", category: "Parking & Transport", icon: "Car" },
    { id: 92, name: "EV Charging", category: "Parking & Transport", icon: "BatteryCharging" },
    { id: 93, name: "Bicycle Rental", category: "Parking & Transport", icon: "Bike" },
    { id: 94, name: "Car Rental", category: "Parking & Transport", icon: "CarFront" },
    { id: 95, name: "Airport Pickup", category: "Parking & Transport", icon: "PlaneLanding" },
    { id: 96, name: "Airport Drop", category: "Parking & Transport", icon: "PlaneTakeoff" },
    { id: 97, name: "Shuttle Service", category: "Parking & Transport", icon: "Bus" },

    // 🧳 Guest Services (FIXED IDS)
    { id: 98, name: "24x7 Front Desk", category: "Guest Services", icon: "Clock" },
    { id: 99, name: "Luggage Storage", category: "Guest Services", icon: "Luggage" },
    { id: 100, name: "Bellboy Service", category: "Guest Services", icon: "Bell" },
    { id: 101, name: "Wake-up Call", category: "Guest Services", icon: "AlarmClock" },
    { id: 102, name: "Tour Assistance", category: "Guest Services", icon: "MapPinned" },

    // ♿ Accessibility
    { id: 103, name: "Wheelchair Accessible", category: "Accessibility", icon: "Wheelchair" },
    { id: 104, name: "Elevator / Lift", category: "Accessibility", icon: "ArrowUpDown" },
    { id: 105, name: "Ramp Access", category: "Accessibility", icon: "TrendingUp" },
    { id: 106, name: "Accessible Bathroom", category: "Accessibility", icon: "Bath" },
    { id: 107, name: "Braille Signage", category: "Accessibility", icon: "Eye" },

    // 🐶 Pet & Family Friendly
    { id: 108, name: "Pet Friendly", category: "Family", icon: "PawPrint" },
    { id: 109, name: "Kids Friendly", category: "Family", icon: "Baby" },
    { id: 110, name: "Crib / Baby Cot", category: "Family", icon: "Bed" },
    { id: 111, name: "High Chair", category: "Family", icon: "Armchair" },
    { id: 112, name: "Babysitting", category: "Family", icon: "UserCheck" },
    { id: 113, name: "Play Area", category: "Family", icon: "Gamepad2" },

    // 🏢 Business & Events
    { id: 114, name: "Business Center", category: "Business", icon: "Briefcase" },
    { id: 115, name: "Meeting Room", category: "Business", icon: "Users" },
    { id: 116, name: "Conference Hall", category: "Business", icon: "Presentation" },
    { id: 117, name: "Printer", category: "Business", icon: "Printer" },
    { id: 118, name: "Scanner", category: "Business", icon: "ScanLine" },
    { id: 119, name: "Projector", category: "Business", icon: "Projector" },
    { id: 120, name: "Whiteboard", category: "Business", icon: "Clipboard" },

        // 🌿 Outdoor & Miscellaneous
    { id: 121, name: "Balcony", category: "Outdoor", icon: "Sun" },
    { id: 122, name: "Terrace", category: "Outdoor", icon: "Mountain" },
    { id: 127, name: "Barbecue", category: "Outdoor", icon: "FlameKindling" },
    { id: 128, name: "Bonfire", category: "Outdoor", icon: "Flame" },
    { id: 123, name: "Mountain View", category: "View", icon: "MountainSnow" },
    { id: 124, name: "Sea View", category: "View", icon: "Waves" },
    { id: 125, name: "City View", category: "View", icon: "Building2" },
    { id: 126, name: "Fireplace", category: "Misc", icon: "Flame" },
    { id: 129, name: "Smoking Area", category: "Misc", icon: "Cigarette" },
    { id: 130, name: "Non-Smoking Rooms", category: "Misc", icon: "Ban" }
];
// Store sub-category that identifies a lodging property. Anything else must not be
// served as a hotel (Google Hotel Ads requires 404 for non-hotel / missing properties).
export const HOTEL_SUB_CATEGORY_ID = 29;
